import { Meteor } from "meteor/meteor";
import App from "../imports/ui/App.svelte";
import { mount, unmount } from "svelte";
import "../imports/startup/client";

let app;

Meteor.startup(() => {
    const target = document.getElementById("app");
    app = mount(App, { target });

    if (import.meta.webpackHot) {
        import.meta.webpackHot.accept();
        import.meta.webpackHot.dispose(() => {
            if (app) {
                unmount(app, { outro: false });
                app = null;
            }
            target.innerHTML = "";
        });
    }
});
